import React from 'react';
import baseContainer from './_baseContainer';
import { ON_NAVIGATION_REQUEST, EMPTY_PAYLOAD, } from '../actions/navigation';
import { OPEN_TAB_EVENT, } from '../actions/tab';

const mapStateToProps = state => ({
  ...state,
  isTabExistent: (key) => {
    const { navigation = {}, } = state;
    const { activeNavItems = [], } = navigation;
    const isExistent = activeNavItems.filter(item => item.key === key).length > 0;
    return isExistent;
  },
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  sendNavigationRequest: (data) => {
    dispatch({ type: ON_NAVIGATION_REQUEST, data, });
    dispatch((dispatcher, getState) => {
      const state = getState();
      const { navigation, } = state;
      if (navigation.payload) {
        dispatcher({
          type: OPEN_TAB_EVENT,
          selectedTab: navigation.payload,
        });

        dispatcher({
          type: EMPTY_PAYLOAD,
        });
      }
    });
  },
});

const mapComponents = (component) => {
  const view = baseContainer(mapStateToProps, mapDispatchToProps)(component);
  return React.createElement(view);
};

export default mapComponents;
